import revive_payload_client_4sVQNw7RlN from "/vercel/path0/v3/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/vercel/path0/v3/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/vercel/path0/v3/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/vercel/path0/v3/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/vercel/path0/v3/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/vercel/path0/v3/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/vercel/path0/v3/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/vercel/path0/v3/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/vercel/path0/v3/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/vercel/path0/v3/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_client_OVoKJro5pc from "/vercel/path0/v3/node_modules/@nuxtjs/color-mode/dist/runtime/plugin.client.js";
import floating_vue_EIcJ7xiw0h from "/vercel/path0/v3/.nuxt/floating-vue.mjs";
import apex_chart_PpDyNBvK2A from "/vercel/path0/v3/plugins/apex-chart.ts";
import apis_QMEwf9g69j from "/vercel/path0/v3/plugins/apis.ts";
import axios_QMFgzss1s4 from "/vercel/path0/v3/plugins/axios.ts";
import buffer_aHHLuY3sF2 from "/vercel/path0/v3/plugins/buffer.ts";
import error_swallower_sWBaipgEnL from "/vercel/path0/v3/plugins/error-swallower.ts";
import exceljs_10EVMZNyQf from "/vercel/path0/v3/plugins/exceljs.ts";
import feature_flags_3X7A4FWWIa from "/vercel/path0/v3/plugins/feature-flags.ts";
import file_saver_Kgx7B4yc6L from "/vercel/path0/v3/plugins/file-saver.ts";
import growthbook_Iy8w9k9ghu from "/vercel/path0/v3/plugins/growthbook.ts";
import gsap_qE0fizvEy0 from "/vercel/path0/v3/plugins/gsap.ts";
import handsontable_HZ9Vikkz0d from "/vercel/path0/v3/plugins/handsontable.ts";
import jira_hqH4ILpAkw from "/vercel/path0/v3/plugins/jira.ts";
import keycloak_3A1ei0WVbX from "/vercel/path0/v3/plugins/keycloak.ts";
import localize_wWI9A0EY8O from "/vercel/path0/v3/plugins/localize.ts";
import modal_UEFnUXzgTX from "/vercel/path0/v3/plugins/modal.ts";
import moment_NWWiRYbNqj from "/vercel/path0/v3/plugins/moment.ts";
import pinia_48xmdi2HHl from "/vercel/path0/v3/plugins/pinia.ts";
import posthog_ulvgx15Dgc from "/vercel/path0/v3/plugins/posthog.ts";
import sentry_3AyO8nEfhE from "/vercel/path0/v3/plugins/sentry.ts";
import tiny_mce_213eodeqVO from "/vercel/path0/v3/plugins/tiny-mce.ts";
import toast_ysMjUcU7eJ from "/vercel/path0/v3/plugins/toast.ts";
import vue_ellipse_progress_k5EegtiWaP from "/vercel/path0/v3/plugins/vue-ellipse-progress.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_client_OVoKJro5pc,
  floating_vue_EIcJ7xiw0h,
  apex_chart_PpDyNBvK2A,
  apis_QMEwf9g69j,
  axios_QMFgzss1s4,
  buffer_aHHLuY3sF2,
  error_swallower_sWBaipgEnL,
  exceljs_10EVMZNyQf,
  feature_flags_3X7A4FWWIa,
  file_saver_Kgx7B4yc6L,
  growthbook_Iy8w9k9ghu,
  gsap_qE0fizvEy0,
  handsontable_HZ9Vikkz0d,
  jira_hqH4ILpAkw,
  keycloak_3A1ei0WVbX,
  localize_wWI9A0EY8O,
  modal_UEFnUXzgTX,
  moment_NWWiRYbNqj,
  pinia_48xmdi2HHl,
  posthog_ulvgx15Dgc,
  sentry_3AyO8nEfhE,
  tiny_mce_213eodeqVO,
  toast_ysMjUcU7eJ,
  vue_ellipse_progress_k5EegtiWaP
]